// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"b346dd36","239":"ad40150f","389":"3f6243c2","455":"22d4e1b1","977":"7a7b0c82"}[chunkId] + ".chunk.js";
};